/**
 * Talala API Gateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MarketplaceAssetObjectV2Object } from './marketplaceAssetObjectV2Object';

export interface MarketplaceAssetObjectV2 {
  type: string;
  object: MarketplaceAssetObjectV2Object;
}
